import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles({
  skeletonWrapper: {
    paddingTop: "20px"
  },
  firstPart: {
    display: "grid",
  },
  secondPart: {
    display: "grid",
    marginTop: "40px"
  },
  firstRow: {
    marginBottom: "50px",
  },
  shortSk: {
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey,
    height: "26px",
    marginBottom: "4px",
  },
  longSk: {
    paddingBottom: "8px",
    marginBottom: "20px",
    marginLeft: "24px",
    height: "60px",
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey,
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      width: "100% !important",
    },
  },
});

export default styles;
